import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container } from "react-bootstrap";

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <Container className="notfound-page text-center">
      <h1 className="notfound-code">404</h1>

      <h3 className="notfound-title">Page introuvable</h3>
      <p className="notfound-text">
        Oups… la page que vous cherchez n’existe pas ou a été déplacée.
      </p>

      <Button className="btn-primary-gold mt-3" onClick={() => navigate("/")}>
        Retour à l’accueil
      </Button>
    </Container>
  );
}
